import { usePrefetchQuery, useQuery } from "@tanstack/react-query";
import { GetHeadToHeadTeamStatsTabQuery } from "@/graphql/gql/graphql";
import { getHeadToHeadTeamStats } from "../api";

const getQueryKey = (numberFireGameId: number) => [
  "headToHeadTeamStats",
  numberFireGameId,
];

const useGetHeadToHeadTeamStats = (numberFireGameId: number) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: getQueryKey(numberFireGameId),
    queryFn: () => getHeadToHeadTeamStats(numberFireGameId),
    retry: false,
    select: (response: GetHeadToHeadTeamStatsTabQuery) => response.event,
  });

  return { data, isLoading, isError, refetch };
};

export const usePrefetchHeadToHeadTeamStats = (numberFireGameId: number) => {
  usePrefetchQuery({
    queryKey: getQueryKey(numberFireGameId),
    queryFn: () => getHeadToHeadTeamStats(numberFireGameId),
    retry: false,
  });
};

export default useGetHeadToHeadTeamStats;
